import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class UserOrgRolesActionsValidator {

    name = [
        Validators.required
    ];

    // label = [
    //     Validators.required,
    //     Validators.pattern('^[a-zA-Z]+$')
    // ];

    module_id = [
        Validators.required
    ]

    permissions = [
        Validators.required
    ]

    // Error messages
    errorMessages = {
        name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        label: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },

            {
                type: 'pattern',
                message: 'MESSAGES.ONLY_ENG_ALLOWED',
                option: null
            }
        ],

        module_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],

        permissions: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}